import React, { useState } from 'react';
import './SubscriptionsTab.css';
import SubscriptionListTab from './SubscriptionListTab';
import TariffsTab from './TariffsTab';
import SubscriptionStatusTab from './SubscriptionStatusTab';

function SubscriptionsTab() {
  const [activeSubTab, setActiveSubTab] = useState('subscriptions');

  return (
    <div className="subscriptions-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'subscriptions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('subscriptions')}
        >
          Подписки
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'tariffs' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('tariffs')}
        >
          Тарифы
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'statuses' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('statuses')}
        >
          Статусы подписок
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'subscriptions' && <SubscriptionListTab />}
        {activeSubTab === 'tariffs' && <TariffsTab />}
        {activeSubTab === 'statuses' && <SubscriptionStatusTab />}
      </div>
    </div>
  );
}

export default SubscriptionsTab;

